(function($) {

windowWidth = $(window).width();

/*
* scroll
*/
$(function(){
	// #で始まるアンカーをクリックした場合に処理
	$('a[href^="#"]').click(function() {
		// スクロールの速度
		var speed = 300; // ミリ秒
		// アンカーの値取得
		var href= $(this).attr("href");
		// 移動先を取得
		var target = $(href == "#" || href == "" ? 'html' : href);
		// 移動先を数値で取得
		if (windowWidth <= 768) {
			var adjust = 0;
		} else{
			var adjust = 0;
		}
		var position = target.offset().top - adjust;
		// スムーススクロール
		$('body,html').animate({scrollTop:position}, speed, 'swing');
		return false;
	});
});

urlHash = location.hash;
$(window).on('load hashchange',function(){
	var urlHash = location.hash;

	if(urlHash) {
		var target = $(urlHash);
		if (windowWidth <= 768) {
			var adjust = 0;
		} else{
			var adjust = 0;
		}
		var position = target.offset().top - adjust;
		$.when(
			$("html, body").animate({
				scrollTop: position
			}, 500, "swing"),
		).done(function() {
			var diff = target.offset().top - adjust;
			if (diff === position) {
			} else {
				$("html, body").animate({
					scrollTop: diff
				}, 10, "swing");
			}
		});
	}
});


/*
* css swicher
*/
function css_browser_selector(u){
	var ua=u.toLowerCase(),
	is=function(t){return ua.indexOf(t)>-1},
	e='edge',g='gecko',w='webkit',s='safari',o='opera',m='mobile',
	h=document.documentElement,
	b=[
		( !(/opera|webtv/i.test(ua)) && /msie\s(\d)/.test(ua))? ('ie ie'+RegExp.$1) :
			!(/opera|webtv/i.test(ua)) && is('trident') && /rv:(\d+)/.test(ua)? ('ie ie'+RegExp.$1) :
			is('edge/')? e:
			is('firefox/2')?g+' ff2':
			is('firefox/3.5')? g+' ff3 ff3_5' :
			is('firefox/3.6')?g+' ff3 ff3_6':is('firefox/3')? g+' ff3' :
			is('gecko/')?g:
			is('opera')? o+(/version\/(\d+)/.test(ua)? ' '+o+RegExp.$1 :
			(/opera(\s|\/)(\d+)/.test(ua)?' '+o+RegExp.$2:'')) :
			is('konqueror')? 'konqueror' :
			is('blackberry')?m+' blackberry' :
			is('android')?m+' android' :
			is('chrome')?w+' chrome' :
			is('iron')?w+' iron' :
			is('applewebkit/')? w+' '+s+(/version\/(\d+)/.test(ua)? ' '+s+RegExp.$1 : '') :
			is('mozilla/')? g:
			'',
			is('j2me')?m+' j2me':
			is('iphone')?m+' iphone':
			is('ipod')?m+' ipod':
			is('ipad')?m+' ipad':
			is('mac')?'mac':
			is('darwin')?'mac':
			is('webtv')?'webtv':
			is('win')? 'win'+(is('windows nt 6.0')?' vista':''):
			is('freebsd')?'freebsd':
			(is('x11')||is('linux'))?'linux':
			'',
			'js'];
	c = b.join(' ');
	h.className += ' '+c;
	return c;
};
css_browser_selector(navigator.userAgent);






/*
* fade
*/
$(function() {
	if (windowWidth <= 768) {
		intersectAction($('.fade'), function (element, isIntersecting) {
			if (isIntersecting) {
				element.addClass('fade-on')
			}
		}, { rootMargin: "0px 0px -40% 0px" }); //　画面下から20%で発火
	} else{
		intersectAction($('.fade'), function (element, isIntersecting) {
			if (isIntersecting) {
				element.addClass('fade-on')
			}
		}, { rootMargin: "0px 0px -25% 0px" }); //　画面下から20%で発火
	}
});



/*
* accordion
*/
$(function () {
	$('.faq_box .faq_ttl').click(function(event){
		$(this).toggleClass('open');

		if ($(this).next('.faq_txt').css('display') == 'none') {
			$(this).next('.faq_txt').slideDown('fast');
		} else {
			$(this).next('.faq_txt').slideUp('fast');
		}

		event.stopPropagation();
	});
});



})(jQuery);